import * as T from './styles';
import CardProjects from './cardProjects';
import { projects } from './cardProjects/projects';
import { IRefProps } from 'interfaces/genericInterfaces';
import { useLanguage } from 'contexts/LanguageContext';

const Projects = ({ reference }: IRefProps) => {
  const { t } = useLanguage();

  return (
    <T.ProjectsContainer ref={reference} className="container">
      <T.TitleRow>
        <T.TitleProjects>{t.projects.title}</T.TitleProjects>
        <T.LineTitle />
      </T.TitleRow>

      <T.ProjectsRow>
        {projects.map((item, index) => {
          return (
            <CardProjects
              key={index}
              url={item.url}
              name={item.name}
              about={item.about}
              preview={item.preview}
            />
          );
        })}
      </T.ProjectsRow>

      <T.GitHubRow>
        <T.TitleGitHub
          onClick={() => {
            window.open('https://github.com/Leocamarggo?tab=repositories');
          }}>
          <i className="fa-brands fa-github"></i>
          {t.projects.seeGitHub}
        </T.TitleGitHub>
      </T.GitHubRow>
    </T.ProjectsContainer>
  );
};

export default Projects;
